import { Button, message } from 'antd'
import { MainApi } from '../api/Main'
import useSubmit from '../elements/Hooks/useSubmit'
import React from 'react'

function GroupLinesButton({ selection, disabled, fetch, setSelection }) {
  const [grouping, groupFunc] = useSubmit(MainApi.group, true)

  async function groupSelection() {
    await groupFunc({ selection })
    setSelection([])
    fetch()
  }

  return (
    <>
      <Button
        size={'small'}
        type={'danger'}
        loading={grouping}
        onClick={groupSelection}
        disabled={disabled}
        style={{ marginLeft: '10px' }}>
        Group
      </Button>
    </>
  )
}

export default GroupLinesButton
